module.exports = __webpack_public_path__ + "static/media/loading.32073107.svg";